<script>

	import { fly } from 'svelte/transition';

	import QR from './Holding/QR.svelte';
	// import Brand from './ui/Brand.svelte';

	import { event, revealMasthead, showSettings } from './lib/stores.js';

	// $: console.log('revealMasthead', $revealMasthead);

</script>

<style>
	.holding {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 98%;
		display: grid;
		place-content: center;
		transition: opacity 0.2s ease;
	}
	.holding > div {
		display: flex;
		gap: 4rem;
		align-items: center;
		max-width: 80vw;
	}
	p {
		font-size: 2rem;
	}
	svg {
		width: 2.4rem;
		vertical-align: middle;
		position: relative;
		top: -0.15rem;
	}
	/*.holding :global(.brand) {
		margin-bottom: 3rem;
	}*/
	.withSettings {
		opacity: 0;
	}
</style>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="holding" class:withSettings={$showSettings} in:fly={{ duration: 400, delay: 400, y: 20 }} on:click={() => { $revealMasthead = !$revealMasthead }}>
	<div>
		<QR/>
		<div>
			<!-- <Brand big={true}/> -->
			<p>
				<span>Install the attendee app<br/>and tap</span>
				<svg viewBox="0 0 32 32"><path d="M19 4.4v2.1c4.1 1.3 7 5.1 7 9.5 0 5.5-4.5 10-10 10s-10-4.5-10-10c0-4.5 2.9-8.3 7-9.5v-2.1c-5.2 1.3-9 6-9 11.6 0 6.6 5.4 12 12 12s12-5.4 12-12c0-5.6-3.8-10.3-9-11.6zM20 21c-.3 0-.5-.1-.7-.3l-4-4c-.2-.2-.3-.4-.3-.7v-12c0-.6.4-1 1-1s1 .4 1 1v11.6l3.7 3.7c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z"/></svg>
				<span>{$event.setup.app.navLabels.now}</span>
			</p>
		</div>
	</div>
</div>